<template>
  <Accordion :error="$v.nfse.receiver.$error" id="receiver" title="TOMADOR">
    <b-row class="row-padding">
      <b-col md="5">
        <SelectClient
          :disabled="disabled"
          :error="$v.nfse.receiver.$error"
          v-model="nfse.receiver"
          @input="changeClient"
        />
      </b-col>
      <b-col md="3">
        <Label>CNPJ:</Label>
        <Input
          disabled
          :key="componentKey"
          :mask="['UUU.UUU.UUU-UU', 'UU.UUU.UUU/UUUU-UU']"
          :value="nfse.receiver.identification"
          :error="$v.nfse.receiver.identification.$error"
        />
      </b-col>
      <b-col md="2">
        <Label>IE:</Label>
        <Input disabled :value="nfse.receiver.stateCode" />
      </b-col>
      <b-col md="2">
        <Label>CEP:</Label>
        <Input
          disabled
          :key="componentKey"
          :mask="['#####-###']"
          :value="address.zipCode.zipCode"
          :error="$v.address.zipCode.zipCode.$error"
        />
      </b-col>
    </b-row>
    <div>
      <div>
        <b-row class="row-padding pt-0">
          <b-col md="4">
            <Label>Endereço:</Label>
            <Input disabled :value="address.street" />
          </b-col>
          <b-col md="1">
            <Label>Número:</Label>
            <Input disabled :value="address.number" />
          </b-col>
          <b-col md="3">
            <Label>Bairro/Distrito:</Label>
            <Input disabled :value="address.neighbourhood" />
          </b-col>
          <b-col md="3">
            <Label>Município:</Label>
            <Input
              disabled
              :value="address.zipCode.city.name"
              :error="$v.address.zipCode.city.name.$error"
            />
          </b-col>
          <b-col md="1">
            <Label>UF:</Label>
            <Input disabled :value="address.zipCode.city.state.acronym" />
          </b-col>
        </b-row>
      </div>

      <b-row class="row-padding pt-0">
        <b-col md="3">
          <Label>Fone Comercial:</Label>
          <Input
            disabled
            :key="componentKey"
            :mask="['####-####', '#####-####']"
            :value="phone.number"
          />
        </b-col>
      </b-row>
    </div>
  </Accordion>
</template>

<script>
import { Accordion, SelectClient, Input } from '@/components';
import { Label } from '@/components/Form';
import { mapGetters, mapState } from 'vuex';
import { required } from '@/reusable/validations';

export default {
  name: 'Receiver',
  components: {
    Accordion,
    Input,
    SelectClient,
    Label,
  },
  validations: {
    address: {
      zipCode: {
        zipCode: { required },
        city: {
          name: { required },
        },
      },
    },
    nfse: {
      receiver: {
        id: { required },
        identification: { required },
      },
    },
  },
  data() {
    return {
      componentKey: 0,
    };
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('nfse', ['getDefaultAddressState', 'getDefaultPhoneState']),
    ...mapState('nfse', ['nfse']),

    address() {
      const { address } = this.nfse.receiver;

      if (!address) return this.getDefaultAddressState;

      return address;
    },
    phone() {
      const { phone } = this.nfse.receiver;

      if (!phone) return this.getDefaultPhoneState;

      return phone;
    },
  },
  methods: {
    changeClient() {
      this.componentKey++;
    },
  },
};
</script>
